<template>
    <div class="text-center" v-if="$apollo.queries.readCardCarouselItems.loading">
        Loading...
    </div>
    <div v-else class="overflow-x-hidden card-scroller"
    >
        <div class="container w-full">
            <div class="flex flex-nowrap items-stretch gap-2 inner align-stretch" :style="carouselSideScrollerStyles">
                <div v-for="item in carouselItems" class="shrink-0 w-[300px]"
                     @click="Lightbox.open(item.imageDisplayMediumSize)">
                    <div>
                        <img :src="item.imageDisplayThumb" class="w-full">
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="container mt-4 flex justify-end">
        <button :disabled='currentItem === 1'
                class='mx-1 flex items-center justify-center p-0 text-center carousel-side-scroller-button'
                @click='navigatePrev'><span class='icon icon-arrow-left'></span></button>
        <button :disabled='currentItem === items.length-itemsFitWidth'
                class='mx-1 flex items-center justify-center p-0 carousel-side-scroller-button'
                @click='navigateNext'><span class='icon icon-arrow-right'></span></button>
    </div>
</template>

<script>


import gql from 'graphql-tag';

export default {
    name: "CardCarousel",
    data: {
        items: [],
        debug: [],
        elementID: 20,
        currentItem: 1,
        calculatedImageWidth: 0,
        initialOffset: -400,
        carouselSideScrollerOffset: 0,
        carouselSideScrollerStyles: {
            'margin-left': '0'
        },
        pageWidth: 0,
        carouselWidth: 0
    },
    computed: {
        carouselItems: function () {
            return (this.readCardCarouselItems.nodes) ? this.readCardCarouselItems.nodes : [];
        },
        itemsWidth: function () {
            return -1 * this.calculatedImageWidth * (this.carouselItems.length - 1);
        },
        itemsFitWidth: function () {
            return Math.floor(this.carouselWidth / this.calculatedImageWidth);
        },
        scrollLimit: function () {
            if (Math.abs(this.itemsWidth) < Math.abs(this.carouselWidth)) {
                return 0;
            }
            this.debug = [this.itemsWidth, this.carouselWidth, (Math.abs(this.itemsWidth) - Math.abs(this.carouselWidth))];

            return Math.abs(this.carouselWidth) - Math.abs(this.itemsWidth);
        }
    },
    watch: {
        carouselWidth: function () {
            this.initialOffset = this.pageWidth / 2 - this.carouselWidth / 2;
        }
    },
    components: {},
    created: function () {
    },
    destroyed: function () {
        window.removeEventListener("resize", this.setWidths);
    },
    mounted: function () {
        initTE({Lightbox});
        this.setWidths();
        window.addEventListener("resize", this.setWidths);
    },
    methods: {
        setWidths: function () {
            this.pageWidth = window.innerWidth;
            this.carouselWidth = (document.getElementsByClassName('spacer')[0]) ? document.getElementsByClassName('spacer')[0].offsetWidth : 0;
        },
        navigateNext: function () {
            ++this.currentItem;
            this.offsetSideScroller();
        },
        navigatePrev: function () {
            --this.currentItem;
            this.offsetSideScroller();
        },
        offsetSideScroller: function () {
            this.calculateOffset();
            this.carouselSideScrollerStyles['margin-left'] = this.carouselSideScrollerOffset + 'px';
        },
        calculateWidth: function () {
            this.calculatedImageWidth = 312.5;
        },
        calculateOffset: function () {
            this.calculateWidth();
            this.carouselSideScrollerOffset = 0 - this.calculatedImageWidth * (this.currentItem - 1);
        }
    },
    apollo: {
        readCardCarouselItems: {
            query: gql`
                query readCardCarouselItems ($elementID: Int) {
                    readCardCarouselItems (filter: { cardCarouselID: {eq: $elementID}}) {
                        nodes {
                          id
                          imageDisplayThumb
                          imageDisplayMediumSize
                          cardCarouselID
                          type
                        }
                    }
                }`,
            variables() {
                return {
                    elementID: this.elementID
                }
            },
            update: function (data) {
                return data.readCardCarouselItems;
            },
            fetchPolicy: 'cache-and-network'
        }
    },
    render: h => h(App),
}
</script>

<style scoped>
::-webkit-scrollbar {
    width: 0px;
    background: transparent; /* make scrollbar transparent */
}

.inner {
    transition: margin-left 0.5s ease-in-out;
}

</style>
